/**
 * Created by lari on 26/04/2017.
 */
(function () {
  'use strict';
  angular.module('vcexam')
    .component('examfield', {
      restrict: 'E',
      bindings: {
        field: '=',
        onFieldChange: '&',
        ti: '@?',
        gi: '@?'
      },
      templateUrl: 'vcexam/examfield-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.loadValues = loadValues;
          
          vm.$onInit = function () {
            // make copy of the field entry originally passed
            vm.laststate = angular.copy(vm.field);
            // calculate tabindex position
            vm.fti = 100 * vm.groupi + vm.tabi;
          };
          
          function save() {
            // save is triggered by onBlur, only save if there really have been changes to the field
            // if field changed, overwrite parent value and trigger parent change handler
            if (!angular.equals(vm.laststate, vm.field)) {
              vm.laststate = angular.copy(vm.field);
              vm.onFieldChange();
            }
          }
          
          // tagsInput expects a promise that will resolve into an array, it doesn't accept arrays
          function loadValues($query) {
            let promise = new Promise(function (resolve, reject) {
                resolve(vm.field.values);
            });
            return promise.then(function (values) {
              return values.filter(function (value) {
                return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
              });
            });
          }
          
        }] // controller
    }); // component

// klammerfriedhof
}());
